import { render, staticRenderFns } from "./DataDisplay.vue?vue&type=template&id=a284e0c0&"
import script from "./DataDisplay.vue?vue&type=script&lang=ts&"
export * from "./DataDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./DataDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports